import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../actions/api";

const slice = createSlice({
  name: "comprehensiveCost",
  initialState: {
    ComprehensiveCostList: [],
    total: 0,
    currentPage: 1,
    toPage: null,
    lastPage: null,
    loading: false,
    error: null,
  },
  reducers: {
    fetchedComprehensiveCostSuccess: (enrollee, action) => {
      enrollee.loading = false;
      enrollee.error = null;
      // Handle the flat array from the API response
      const data = action.payload.data || action.payload;
      enrollee.ComprehensiveCostList = Array.isArray(data) ? data : [];
      enrollee.total = data.length;
      enrollee.currentPage = 1; // No pagination in API response, default to 1
      enrollee.toPage = data.length; // Set to total items
      enrollee.lastPage = 1; // No pagination, so only 1 page
    },
    fetchedComprehensiveCostStart: (enrollee, action) => {
      enrollee.loading = true;
    },
    fetchedComprehensiveCostFailed: (enrollee, action) => {
      enrollee.loading = false;
      enrollee.error = action.payload || { message: "Failed to fetch data" };
    },
  },
});

const {
  fetchedComprehensiveCostSuccess,
  fetchedComprehensiveCostStart,
  fetchedComprehensiveCostFailed,
} = slice.actions;

export default slice.reducer;

const url = "/v1/admin/cost-centres";

export const fetchComprehensiveCosts = (pageItems, page) =>
  apiCallBegan({
    url: `${url}?page_items=${pageItems}&page=${page}`,
    method: "GET",
    onSuccess: fetchedComprehensiveCostSuccess.type,
    onStart: fetchedComprehensiveCostStart.type,
    onError: fetchedComprehensiveCostFailed.type,
  });

export const getComprehensiveCosts = (state) =>
  state.entities.enrolleeComprehensiveCosts;
